<template>
    <div class="content-body">
        <div class="card mb-0">
            <div class="card-content">
                <div class="card-body">
                    <h4>Savol turi: Bittalik tanlov</h4>
                    <h4 class="d-flex align-items-center">
                        Savol:
                        <span v-html="question.question" style="margin-top: 13px; margin-left: 8px;"></span>
                    </h4>
                    <h4>Балл: {{ question.ball }}</h4>
                    <h4>Ответы: </h4>
                    <ul class="list-group mb-1">
                        <li class="list-group-item py-0" v-for="(answerItem, index) in answers">
                            <div class="d-flex align-items-center">
                                <div class="mr-1">{{ index + 1 }}.</div>
                                <div>
                                    <div class="vs-radio-con">
                                        <input type="radio" disabled="disabled" :checked="answerItem.key" name="vueradio">
                                        <span class="vs-radio">
                                            <span class="vs-radio--border" />
                                            <span class="vs-radio--circle" />
                                        </span>
                                        <span v-html="answerItem.answer" class="pt-1" />
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <button class="btn btn-outline-primary" data-dismiss="modal">
                        Назад
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SingleSelectionModal",
        props: {
            question: Object,
            answers: Array
        },
        methods: {
        },
        watch: {
        },
        created() {

        }

    }
</script>

<style scoped>

</style>